import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.less";
import NotFound from "./components/Notfound";
import AboutUs from "./pages/About";
import Home from "./pages/Home";
import Portfolio from "./pages/Portfolio";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import MainWrapper from "./components/MainWrapper";
import { ROUTES } from "./constants";
// import Login from "./pages/Auth/Login";
// import Signup from "./pages/Auth/Signup";
// import GettingStarted from "./pages/GettingStarted";
import ContactForm from "./components/ContactForm";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ComingSoon from "./components/ComingSoon";
import { PrivateRoute, PublicRoute } from "./components/RouteWrapper";
import ProfilePage from "./pages/Profile";
import DashboadPage from "./pages/Dashboard";

const publicRoutes = [
    { path: ROUTES.HOME, component: <Home /> },
    { path: ROUTES.PORTFOLIO, component: <Portfolio /> },
    { path: ROUTES.ABOUTUS, component: <AboutUs /> },
    { path: ROUTES.LOGIN, component: <ComingSoon /> },
    { path: ROUTES.SIGNUP, component: <ComingSoon /> },
    { path: ROUTES.GETTING_STARTED, component: <ComingSoon /> },
    { path: ROUTES.POLICY, component: <PrivacyPolicy /> },
];

const privateRoutes = [
    { path: ROUTES.DASHBOARD, component: <DashboadPage /> },
    { path: ROUTES.PROFILE, component: <ProfilePage /> },
];

const App = () => {
    return (
        <div className="yudl-container">
            <Router>
                <Navbar />
                <Routes>
                    {publicRoutes.map(({ path, component }, i) => (
                        <Route
                            key={i}
                            path={path}
                            element={<PublicRoute children={<MainWrapper children={component} />} />}
                        />
                    ))}
                    {privateRoutes.map(({ path, component }, i) => (
                        <Route
                            key={i}
                            path={path}
                            element={<PrivateRoute children={<MainWrapper children={component} />} />}
                        />
                    ))}
                    <Route path="*" element={<MainWrapper children={<NotFound />} />} />
                </Routes>
                <Footer />
            </Router>
            <ContactForm />
        </div>
    );
};

export default App;
